import React, { Component } from 'react';
import PropTypes from 'prop-types';

import StepWizard from './components/step-wizard';
import {
  MortgagePurpose,
  Income,
  MortgageTerm,
  SavingsAvailable,
  BestMortgage,
  Form,
  Congrats
} from './components/Steps';
import Footer from './components/Footer';
import fetchMortgageOptions, { minimumRecommendedSavingsAmount } from './api/calculator';

import './App.css';
import storeUsersData from './api/usersData';

class App extends Component {
  state = {
    purpose: null,
    income: null,
    term: null,
    error: null,
    mortgageOptions: { error: null, options: [] },
    isFetchingMortgageOptions: false,
    provinceId: null
  };

  postMessage = data => window.parent.postMessage(data, process.env.REACT_APP_IFRAME_HOST);

  onTermSelected = async newTerm =>
    new Promise(async resolve => {
      this.setState({ term: newTerm, isFetchingMortgageOptions: true }, async () => {
        resolve();
        const { purpose, term, income, savings } = this.state;
        const { provinceId, price } = this.props;
        try {
          const mortgageOptions = await fetchMortgageOptions({
            price,
            provinceId,
            savings,
            term,
            purpose,
            income
          });
          this.setState({ mortgageOptions, isFetchingMortgageOptions: false, provinceId, price });
        } catch (error) {
          this.setState({ error: error.message, isFetchingMortgageOptions: false });
        }
      });
    });

  onAddedUserData = async ({ name, surname, email, phone }) => {
    // eslint-disable-next-line react/no-unused-state
    this.setState({ name, surname, email, phone, isFetchingMortgageOptions: true, error: null });

    const { price, provinceId, savings, income, option } = this.state;
    try {
      const res = await storeUsersData({
        name,
        surname,
        email,
        phone,
        price,
        provinceId,
        savings,
        income,
        option
      });
      this.setState({ isFetchingMortgageOptions: false });
      if (res.results.message) {
        await this.setState({ error: 'ha ocurrido un error en tu búsqueda' });
      }
      this.postMessage({ event: 'goToLastStep', res });
    } catch (error) {
      await this.setState({ error: 'ha ocurrido un error en tu búsqueda', isFetchingMortgageOptions: false });
    }
  };

  onMortgageSelected = option => {
    const { provinceId } = this.state;
    this.setState({ option });
    this.postMessage({ event: 'goToStep5', provinceId, option });
  };

  MortgagePurposeContainer = ({ nextStep }) => (
    <MortgagePurpose
      onSelectOption={purpose => {
        this.setState({ purpose });
        nextStep();
        this.postMessage({ event: 'goToStep1' });
      }}
    />
  );

  IncomeContainer = ({ nextStep, previousStep }) => (
    <Income
      onSelectOption={income => {
        this.setState({ income });
        nextStep();
        this.postMessage({ event: 'goToStep2' });
      }}
      onClickBackButton={previousStep}
      stepTitle="1 / 5"
    />
  );

  SavingsAvailableContainer = ({ nextStep, previousStep }) => {
    const { purpose } = this.state;
    const { price } = this.props;
    const minRecommendedSavingsAmount = minimumRecommendedSavingsAmount(price, purpose);
    return (
      <SavingsAvailable
        onSelectOption={savings => {
          this.setState({ savings });
          nextStep();
          this.postMessage({ event: 'goToStep3' });
        }}
        onClickBackButton={previousStep}
        initialAmount={minRecommendedSavingsAmount}
        minRecommendedSavingsAmount={minRecommendedSavingsAmount}
        maxAmount={price}
        stepTitle="2 / 5"
      />
    );
  };

  MortgageTermContainer = ({ nextStep, previousStep }) => (
    <MortgageTerm
      onSelectOption={async term => {
        this.setState({ error: null });
        await this.onTermSelected(term);
        nextStep();
        this.postMessage({ event: 'goToStep4' });
      }}
      onClickBackButton={previousStep}
      stepTitle="3 / 5"
    />
  );

  BestMortgageContainer = ({ nextStep, previousStep }) => {
    const { isFetchingMortgageOptions, mortgageOptions, error } = this.state;
    if (mortgageOptions && mortgageOptions.options.length > 0) {
      const { options } = mortgageOptions;
      const fixed = options.filter(option => option.interestType === 'F')[0];
      const variable = options.filter(option => option.interestType === 'V')[0];
      const minMonthlyQuotaFixed = fixed ? fixed.monthlyQuota : null;
      const numBanksFixed = fixed ? fixed.total : null;
      const minMonthlyQuotaVariable = variable ? variable.monthlyQuota : null;
      const numBanksVariable = variable ? variable.total : null;

      this.postMessage({
        event: 'mortgageInfo',
        minMonthlyQuotaFixed,
        numBanksFixed,
        minMonthlyQuotaVariable,
        numBanksVariable
      });
    }
    return (
      <BestMortgage
        onSelectOption={option => {
          this.onMortgageSelected(option);
          nextStep();
          this.postMessage({ event: 'goToStep5' });
        }}
        onClickBackButton={previousStep}
        isFetchingMortgageOptions={isFetchingMortgageOptions}
        options={mortgageOptions}
        error={error}
      />
    );
  };

  FormContainer = ({ nextStep, previousStep }) => (
    <Form
      onSelectOption={userData => {
        this.onAddedUserData(userData);
        nextStep();
      }}
      // eslint-disable-next-line react/destructuring-assignment
      isFetchingMortgageOptions={this.state.isFetchingMortgageOptions}
      onClickBackButton={previousStep}
      stepTitle="5 / 5"
    />
  );

  CongratsContainer = ({ previousStep }) => (
    // eslint-disable-next-line react/destructuring-assignment
    <Congrats onClickBackButton={previousStep} stepTitle="Éxito!" error={this.state.error} />
  );

  render() {
    return (
      <div className="wizardWrapper">
        <StepWizard>
          <this.MortgagePurposeContainer />
          <this.IncomeContainer />
          <this.SavingsAvailableContainer />
          <this.MortgageTermContainer />
          <this.BestMortgageContainer />
          <this.FormContainer />
          <this.CongratsContainer />
        </StepWizard>
        <Footer />
      </div>
    );
  }
}

App.propTypes = {
  price: PropTypes.number.isRequired,
  provinceId: PropTypes.number.isRequired
};

export default App;
